import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import { ICustomPrice } from '../../interface'
import { useContext } from 'react'
import { ProductContext } from './EducationLayout'
import EducationMetadataBlock from './EducationMetadataBlock'

interface ICustomAccordionContent {
  data: ICustomPrice
}

const CustomAccordionContent = ({ data }: ICustomAccordionContent) => {
  const product = useContext(ProductContext)
  const { descriptions, href, buttonName, price } = data
  const isSubscription = href.includes('membership')
  // Convert camelCase to Snake_Case format
  const ctaName = buttonName
    .split('.')[1]
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/^([a-z])/, (match) => match.toUpperCase())

  return (
    <>
      {descriptions.map((description, index) => (
        <Typography key={index}>
          <FormattedMessage id={description} values={{ product }} />
        </Typography>
      ))}
      {!!price && (
        <Box sx={{ my: 2 }}>
          <EducationMetadataBlock title='education.metadata.price' data={price} isSubscription={isSubscription} />
        </Box>
      )}
      <Button data-gtm-primary-cta={ctaName} component={Link} to={href} variant='contained' sx={{ mt: 2 }}>
        <FormattedMessage id={buttonName} />
      </Button>
    </>
  )
}

export default CustomAccordionContent
